import { rem } from '@helpers/Constants/rem';

export function uuid() {
  var s = [];
  var hexDigits = '0123456789abcdef';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[8] = s[13] = s[18] = s[23] = '-';
  var uuid = s.join('');
  return uuid;
}

// 原宽度 原高度 画布宽度 画布高度 适配模式
export function getFitSize(sWidth: number, sHeight: number, width: number, height: number, mode?: 'contain' | 'cover') {
  const size = { width, height };
  const scale = sWidth / sHeight;
  mode = mode || 'contain';
  if (
    (scale > width / height && mode === 'cover') ||
    (scale < width / height && mode === 'contain')
  ) {
    size.width = Math.floor(height * scale);
  } else {
    size.height = Math.floor(width / scale);
  }
  return size;
}


/**
 * 把 style 里面的 px 值转成 rem 值，如
 * {
 *   fontSize: '32px',
 *   width: '100px',
 * }
 *
 * 转成
 *
 * {
 *   fontSize: '0.5rem',
 *   width: '1.6rem'
 * }
 * 注意！如果是 px ，务必加上 px 单位
 * @param originStyle
 */
 export const handleStylePx2rem = (
  originStyle: React.CSSProperties
): React.CSSProperties => {
  const styles: React.CSSProperties = {};
  // px转rem处理
  for (const key in originStyle) {
    if (originStyle.hasOwnProperty(key)) {
      const value = (originStyle as any)[key];
      if (typeof value === 'number') {
        (styles as any)[key] = px2rem(value);
      } else {
        const value = (originStyle as any)[key].toString();
        (styles as any)[key] = value.replace(/[1-9]\d*px/gi, (px: string) => {
          return px2rem(parseInt(px));
        });
      }
    }
  }
  return styles;
};

/**
 * 获取px转化为对应的rem值
 * @param pxNum px值
 * @return {string} px对应的rem值
 */
export function px2rem(pxNum: number): string {
  const result = pxNum / 100;
  return result + 'rem';
}

/**
 * 获取根据flexibleRem比例计算的px值
 * @param pxNum px值
 * @return {number} 对应比例的px值
 */
export function getPx(pxNum: number): number {
  let result = pxNum / 100 * rem;
  // 保留2位小数值，防止安卓端渲染异常
  result = Math.floor(result * 100) / 100;
  return result;
}